<ng-container *ngIf="!product && (isDesktopDevice || isTablet)">
  <ngx-skeleton-loader animation="progress" appearance="line" [theme]="{
     'height.px': 50,
     'background-color': '#F7F7F7'
     }">
  </ngx-skeleton-loader>
  <section class="images-section mt-2" *ngIf="!product">
    <div class="container">
      <ngx-skeleton-loader animation="progress" appearance="line">
      </ngx-skeleton-loader>
    </div>
  </section>
  <ngx-skeleton-loader animation="progress" appearance="line" [theme]="{
     'height.px': 200,
     'background-color': '#F7F7F7'
     }">
  </ngx-skeleton-loader>
</ng-container>
<ng-container *ngIf="!product && isMobile">
  <ngx-skeleton-loader animation="progress" appearance="line" [theme]="{
     'height.px': 50,
     'background-color': '#F7F7F7'
     }">
  </ngx-skeleton-loader>
  <section class="mt-2" *ngIf="!product">
    <div class="container">
      <ngx-skeleton-loader animation="progress" appearance="line" [theme]="{
           'height.px': 500,
           'background-color': '#F7F7F7'
           }">
      </ngx-skeleton-loader>
    </div>
  </section>
  <ngx-skeleton-loader animation="progress" appearance="line" [theme]="{
     'height.px': 100,
     'background-color': '#F7F7F7'
     }">
  </ngx-skeleton-loader>
</ng-container>
<!-- Common Header-->
<app-header extraClass="text-gray hideMobile" displayNavigation=true
  [standardProduct]="product.details.product_type == 'STANDARD'?true:false" *ngIf="product"></app-header>
<ng-container *ngIf="responseReceived && product.details.product_type !== 'STANDARD'">
  <!--CENTER SLIDER-->
  <section class="center-slider-wrp video-img-slider details-page-view mt-8">
    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">
      <ul class="uk-slider-items uk-grid-match mob-sli" uk-lightbox="animation:scale">
        <li *ngIf="isDesktopDevice && product.details.master_video" class="uk-width-3-4">
          <div class="uk-panel">
            <a href="{{product.details.master_video}}" data-caption="Video" data-type="video">
              <video height="100%" width="100%" class="lazy" loop="1" preload="auto" controls autoplay
                id="desktop-master-video" [src]="product.details.master_video">
              </video>
            </a>
          </div>
          <div class="center-icon-play-video">
            <div class="play-btn" video-autoplay="true">
              <a href="" data-caption="Video">
                <img src="./assets/images/icons/play.png" alt="" class="play">
              </a>
            </div>
          </div>
        </li>
        <ng-container *ngIf="isMobile && product.reel_videos.length > 0">
          <li *ngFor="let reelVideo of product.reel_videos; let i =index" class="mobile-reel-video">
            <div class="video-thumbnail position-relative">
              <div class="">
                <a href="{{reelVideo.video}}" data-caption="Reel Video" data-type="video">
                  <video id="reel_video_{{i}}" playsinline loop="1" preload="metadata" muted=""
                    (click)="playVideo($event.target)" src="{{reelVideo.video}}#t=0.1">
                  </video>
                </a>
              </div>
              <div class="center-icon-play-video" id="reel_video_button_{{i}}">
                <div class="play-btn">
                  <a href="{{reelVideo.video}}" data-caption="Reel Video" data-type="video">
                    <img src="./assets/images/icons/play.png" alt="" class="play"
                      (click)="playVideoByID('reel_video_'+i,'reel_video_button_'+i)">
                  </a>
                </div>
              </div>
            </div>
          </li>
        </ng-container>
        <li class="uk-width-3-4" *ngFor="let image of product.product_images">
          <div class="uk-panel">
            <a href="{{image.images}}">
              <img src="{{image.images}}" class="img-width" alt="{{image.title}}">
            </a>
          </div>
        </li>
      </ul>
      <a class="btn-view-all formobilesli" (click)="openSlideShow()">
        <img src="assets/images/icons/gallery-icon.png"> Show All
      </a>
      <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
      <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
      <!-- 27 aug VIP-->
      <div class="hidelg">
        <div class="back-link uk-flex uk-flex-between">
          <a [routerLink]="['/'+this.pageCity+'/exclusives']">
            <img src="assets/images/icons/white-arrow.png" alt="">
          </a>
          <div class="share-box">
            <app-sharing [PageURL]="pageURL" [PageFeaturedImage]="pageFeaturedImage"></app-sharing>
            <app-wishlist [productData]=product></app-wishlist>
          </div>
        </div>
      </div>
      <!--      <ul class="progress-donut hidelg">-->
      <!--        <li *ngFor="let reelVideo of product.reel_videos; let i = index" uk-slideshow-item="{{i+1}}">-->
      <!--          <a href="#"></a>-->
      <!--        </li>-->
      <!--        <li *ngFor="let image of product.product_images; let i = index;"-->
      <!--            uk-slideshow-item="{{(i + 1+ product.reel_videos.length)}}">-->
      <!--          <a href="#"></a>-->
      <!--        </li>-->
      <!--      </ul>-->
      <ul class="progress-donut hidelg">
        <li *ngFor="let reelVideo of product.reel_videos; let i = index" uk-slider-item="{{i}}">
          <a href="#"></a>
        </li>
        <li uk-slider-item="{{i+product.reel_videos.length}}"
          *ngFor="let image of product.product_images; let i = index">
          <a href="#"></a>
        </li>
      </ul>
      <!-- 27 aug VIP-->
    </div>
  </section>
  <!--Skeleton Loader-->
  <!-- <section class="center-slider-wrp video-img-slider mt-8" *ngIf="!responseReceived">
     <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">
         <ul class="uk-slider-items uk-grid-match">
             <li class="uk-width-3-4" *ngFor="let image of product.product_images">
                 <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
             </li>
         </ul>
     </div>
     </section> -->
  <!--MOBILE BOOK NOW CARD-->
  <section class="book-now-card uk-flex hidelg" *ngIf="responseReceived">
    <div class="uk-flex uk-flex-between uk-flex-middle">
      <div class="price">
        <span>Starting from</span>
        <p><i class="fa fa-rupee"></i> {{product.details.sale_price | currency:'INR':'':'1.0-0'}}</p>
      </div>
      <div class="btn">
        <button type="submit" class="btn-yellow btn-full" (click)="addToCart()">
          {{availabilityPresent ? 'Buy Now' : 'Sold Out! Select another date'}}
        </button>
      </div>
      <!-- <div class="btn">
         <a [routerLink]="['enquiry/'+product.details.id]" class="btn-default">Book Now</a>
         </div> -->
      <span class="error" *ngIf="isDesktopDevice"> {{checkoutError}}</span>
    </div>
  </section>
  <!--KEY HIGHLIGHT-->
  <section class="wrapper christmasTheme">
    <div class="container">
      <div class="uk-flex container-inner">
        <div class="w-70">
          <section class="key-highlight-wrp mb-4" *ngIf="responseReceived">
            <div class="key-highlight-wrp-inner uk-flex">
              <div class="key-highlight-info" *ngIf="responseReceived">
                <div class="key-highlight-info-header">
                  <h6>
                    <!--<img src="assets/images/christmas/location-black.png"
                       alt="">-->
                    <!-- <img src="assets/images/icons/location-black.png"
                          alt="">-->
                    <i class="fa fa-map-marker"></i>&nbsp; {{product.details.sub_locality ? product.details.sub_locality
                    : product.details.city}}
                  </h6>
                  <h4>{{product.details.title}}</h4>
                  <div class="uk-flex uk-flex-middle">
                    <span>{{product.details.category_name}} </span>
                    <div class="position-relative uk-margin-small-left">
                    </div>
                  </div>
                </div>
                <!--key-highlight-info-header-->
                <div class="view-list mt-15">
                  <ul class="uk-flex">
                    <li>
                      <!-- <img src="/assets/images/icons/eye-2.png" alt="">-->
                      <i class="fa fa-eye"></i>&nbsp;{{product.matrix ? product.matrix.view_count : 1}} People Viewed
                    </li>
                    <li>
                      <!--<img src="assets/images/icons/star.png" alt=""> 4.5 Rating-->
                    </li>
                  </ul>
                </div>
                <div class="key-highlight-info-details mt-3">
                  <p>{{product.details.description}}</p>
                  <div uk-lightbox *ngIf="product.details.master_video">
                    <a href="{{product.details.master_video}}" data-caption="Watch Video" class="btn-default mt-3">
                      <!--<img src="assets/images/icons/arrow-right-fill.png" alt="">--> <i class="fa fa-play"
                        aria-hidden="true"></i>&nbsp;
                      WATCH VIDEO
                    </a>
                  </div>
                </div>
                <!--key-highlight-info-details-->
              </div>
            </div>
          </section>
          <!--MOBILE VIEW-->
          <section class="mobilevideoview hidelg mb-4" hidden *ngIf="responseReceived">
            <h4>{{product.details.title}}</h4>
            <div class="video-thumbnail position-relative">
              <div class="video-poster" data-src="images/video-poster-3.jpg" uk-img>
                <div class="video-hightlight center-icon">
                  <div class="play-btn">
                    <img src="assets/images/icons/play.png" alt="" class="play playVideo cursor-pointer">
                  </div>
                </div>
              </div>
              <div class="video-stream">
                <video class="lazy" loop="1" preload="auto" playsinline uk-cover uk-video="autoplay: inview">
                  <source data-src="assets/images/video/video-1.mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
                </video>
              </div>
            </div>
          </section>
          <!--RELATED VIDEO-->
          <section class="more-related-video-wrp mb-5 hideMobile " *ngIf="responseReceived">
            <h4>The Virtual Tour</h4>
            <div class="related-video-slider">
              <div uk-slider="sets: true;center: true">
                <div class="uk-position-relative">
                  <div class="uk-slider-container uk-light">
                    <ul uk-lightbox
                      class="uk-slider-items uk-child-width-1-3@s uk-child-width-1-3@m uk-grid uk-grid-small">
                      <li *ngFor="let reelVideo of product.reel_videos">
                        <div class="video-thumbnail position-relative">
                          <div class="video-poster">
                            <video class="lazy" uk-cover="autoplay:false; automute:false">
                              <source data-src="{{reelVideo.video}}" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
                            </video>
                            <div class="video-hightlight center-icon">
                              <div class="play-btn" video-autoplay="true">
                                <a href="{{reelVideo.video}}" data-caption="Video">
                                  <img src="assets/images/icons/play.png" alt="" class="play">
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li *ngFor="let images of productSpliceImages; index as i;">
                        <div class="assets/images-block">
                          <div class="{{imageIndex%2===0?'image-top':'image-bottom'}}"
                            *ngFor="let image of images; index as imageIndex">
                            <a href="{{image.images}}" data-caption="">
                              <img src="{{image.images}}" alt="{{image.title}}">
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <a class="uk-position-center-left-out custom-nav" href="#" uk-slidenav-previous
                    uk-slider-item="previous">
                    <img src="assets/images/icons/arrow-right.png" alt="">
                  </a>
                  <a class="uk-position-center-right-out custom-nav" href="#" uk-slidenav-next uk-slider-item="next">
                    <img src="assets/images/icons/arrow-right.png" alt="">
                  </a>
                </div>
              </div>
            </div>
            <!--related-video-slider-->
          </section>
          <!--Skeleton Loader-->
          <section class="more-related-video-wrp mb-5 hideMobile " *ngIf="!responseReceived" hidden>
            <div class="related-video-slider">
              <div uk-slider="sets: true;center: true">
                <div class="uk-position-relative">
                  <div class="uk-slider-container uk-light">
                    <ul class="uk-slider-items uk-child-width-1-3@s uk-child-width-1-3@m uk-grid uk-grid-small">
                      <li *ngFor="let images of productSpliceImages; index as i;">
                        <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!--related-video-slider-->
          </section>
          <!--Skeleton Loader-->
          <section class="spotlight-wrp" *ngIf="!responseReceived">
            <div class="spotlight-wrp-inner">
              <div class="uk-flex spotlight-card-wrp uk-flex-wrap uk-flex-between">
                <div class="spotlight-card w-49" *ngFor="let highlight of product.key_highlights">
                  <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
                </div>
              </div>
            </div>
          </section>
          <!--Skeleton Loader-->
          <!-- <section class="the-plan-wrp mt-3" *ngIf="!responseReceived">
             <div class="the-plan-wrp-inner">
             <div class="progress-listx">
             <ul>
             <li *ngFor="let what_to_expect of product.what_to_expect; index as i">
             <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
             </li>
             </ul>
             </div>
             </div>
             </section> -->
          <!--THE CONCLUSION-->

          <!--$('.acc-title').click(function(){$(this).toggleClass('active')});-->
          <section class="details-other-info-wrp mt-3" *ngIf="responseReceived">
            <div class="details-other-info-wrp">
              <div class="gray-accordion mb-3">
                <ul uk-accordion>
                  <li>
                    <a class="acc-title active" href="javascript:void(0)" (click)="toggleAccordion($event.target)"> The
                      Spotlight</a>
                    <div class="acc-content">
                      <!--SPOTLIGHT-->
                      <section class="spotlight-wrp mt-2" *ngIf="responseReceived">
                        <div class="spotlight-wrp-inner">
                          <!--  <h4 class="heading-w-border">
                             The Spotlight
                             </h4>-->
                          <div class="uk-flex spotlight-card-wrp uk-flex-wrap uk-flex-between">
                            <div class="spotlight-card w-49" *ngFor="let highlight of product.key_highlights">
                              <img src="{{highlight.key_icon}}" alt="">
                              <h4>{{highlight.title}}</h4>
                              <p>{{highlight.keydesc}}</p>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--spotlight-wrp-->
                    </div>
                  </li>
                  <li>
                    <a class="acc-title" href="javascript:void(0)" (click)="toggleAccordion($event.target)"> The
                      Inclusions</a>
                    <div class="acc-content">
                      <div class="mt-2">
                        <!-- <h5>Terms and Conditions</h5>-->
                        <ng-container *ngIf="product.what_included.length > 0">
                          <div class="inclusion-card-wrp uk-flex uk-flex-wrap">
                            <div class="inclusion-card uk-flex w-49"
                              *ngFor="let whats_included of product.what_included">
                              <div class="icon">
                                <img
                                  src="assets/images/icons/{{whats_included.action === 'Checked'?'right.png':'wrong.png'}}"
                                  alt="">
                              </div>
                              <div class="info">
                                {{whats_included.title}}
                              </div>
                            </div>
                            <!--inclusion-card-->
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </li>
                  <li>
                    <a class="acc-title" href="javascript:void(0)" (click)="toggleAccordion($event.target)">The Plan</a>
                    <div class="acc-content">
                      <!--THE PLAN-->
                      <section class="the-plan-wrp mt-3" *ngIf="responseReceived">
                        <div class="the-plan-wrp-inner">
                          <div class="progress-list">
                            <ul>
                              <li *ngFor="let what_to_expect of product.what_to_expect; index as i"
                                class="{{ i > 2?'ShowList':''}}">
                                <a class="uk-flex list-group">
                                  <div class="list-circle list-line"></div>
                                  <div class="details">
                                    <h4>{{what_to_expect.day}}</h4>
                                    <h5><span
                                        class="{{what_to_expect.action==='Green'?'text-green':'text-red'}}">{{what_to_expect.time}}</span>
                                      - {{what_to_expect.place}}
                                    </h5>
                                    <p>{{what_to_expect.description}}</p>
                                  </div>
                                </a>
                              </li>
                              <li *ngIf="product.what_to_expect.length > 3">
                                <a class="uk-flex list-group uk-flex-middle Show-more-step">
                                  <div class="list-circle list-line"></div>
                                  <div class="details link" (click)="expandList($event.target)">
                                    Show more
                                  </div>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <!--additional-details-list-->
                        </div>
                      </section>
                    </div>
                  </li>
                  <li>
                    <a class="acc-title" href="javascript:void(0)" (click)="toggleAccordion($event.target)">The Fine
                      Print</a>
                    <div class="acc-content">
                      <div class="terms-wrp">
                        <ul>
                          <li *ngFor="let tnc of product.the_fine_print_tandc">
                            {{tnc.title}}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li>
                    <a class="acc-title" href="javascript:void(0)" (click)="toggleAccordion($event.target)">Cancellation
                      Policy</a>
                    <div class="acc-content">
                      <div class="cancel-policy mt-2">
                        <p>
                          <ng-container *ngFor="let cancellation of product.the_fine_print_cancellation">
                            {{cancellation.title}}
                          </ng-container>
                          <a [routerLink]="['/terms-and-conditions']" class="text-green">Learn more about
                            cancellations</a>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <!--w-70-->
        <div class="w-30 hideMobile">
          <div class="wishlist-sharing" *ngIf="responseReceived">
            <div class="uk-flex uk-flex-middle">
              <div class="position-relative listshare">
                <i class="fa fa-share-alt cursor-pointer opensharelink sharing-link" (click)="openShareLink()"></i>
                <div class="sharelink uk-flex" *ngIf="responseReceived">
                  <share-buttons [theme]="'default'"
                    [include]="['facebook','twitter','telegram','whatsapp','sms','email']" [show]="9" [size]="1"
                    [url]="pageURL" [image]="pageFeaturedImage" [autoSetMeta]="false"></share-buttons>
                </div>
              </div>
              <app-wishlist [productData]=product></app-wishlist>
            </div>
          </div>
          <!--wishlist-sharing-->
          <div class="guest-booking" uk-sticky="offset: 100;bottom: true" *ngIf="productEventsAvailable">
            <form #enquiryForm="ngForm" method="post">
              <div class="guest-card uk-flex uk-flex-middle datepicker">
                <div class="icon fa-icon1">
                  <!--<img src="assets/images/icons/calendar-2.png" alt="">-->
                  <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <h4>Date</h4>
                  <input class="uk-input" id="input-select-date" placeholder="Select Date" type="date"
                    name="occasion_date" required="required" max="{{maxDate | date:'yyyy-MM-dd'}}"
                    [(ngModel)]="productSchedule.date" min="{{minDate | date:'yyyy-MM-dd'}}"
                    value="{{minDate | date:'dd-MM-yyyy'}}" (change)="fillTime($event.target)">
                  <!-- <mat-form-field class="example-full-width" appearance="fill" *ngIf="dateFilter">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="picker" name="occasion_date"
                           required="required" max="2022-08-01" [(ngModel)]="productSchedule.date"
                           min="{{minDate | date:'yyyy-MM-dd'}}"
                           (dateChange)="fillTime($event.target)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field> -->
                </div>
              </div>
              <div class="guest-card uk-flex uk-flex-middle mt-1">
                <div class="icon fa-icon2">
                  <!-- <img src="assets/images/icons/people-2.PNG" alt="">-->
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <h4>Time Slot</h4>
                  <div uk-form-custom="target: > * > span:first-child">
                    <select
                      class="uk-select {{productEvents[productSchedule.date] && productEvents[productSchedule.date].length === 1 ?'no-arrow':''}} "
                      id="select-time-slot" name="time_slot" [(ngModel)]="productSchedule.time" (change)="fillGuests()"
                      *ngIf="productSchedule.date"
                      disabled="{{productEvents[productSchedule.date] && productEvents[productSchedule.date].length === 1?'true':'false'}}">
                      <ng-container *ngFor="let time of productEvents[productSchedule.date]">
                        <option value="{{time.time_from}}-{{time.time_to}}">
                          {{(time.time_from !== '0:00' && time.time_from !== '00:00') ? time.time_from + '-' +
                          time.time_to : 'Subject to Availability'}}
                        </option>
                      </ng-container>
                    </select>
                    <button type="button" tabindex="-1">
                      <span></span>
                      <i class="fa fa-angle-down" aria-hidden="true"
                        *ngIf="productSchedule.date && (productEvents[productSchedule.date] && productEvents[productSchedule.date].length > 1)">
                      </i></button>
                  </div>
                </div>
              </div>
              <div class="guest-card uk-flex uk-flex-middle mt-1">
                <div class="icon fa-icon3">
                  <!--<img src="assets/images/icons/people-2.PNG" alt="">-->
                  <i class="fa fa-users" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <h4>Guests</h4>
                  <div uk-form-custom="target: > * > span:first-child">
                    <select class="uk-select" name="number_of_guest" [(ngModel)]="productSchedule.ppl"
                      (change)="setPrice()" disabled="{{NoOfGuests.length === 1?'true':'false'}}">
                      <option selected value="0">Please select</option>
                      <ng-container *ngIf="productSchedule.date">
                        <ng-container *ngFor="let time of NoOfGuests">
                          <option value="{{time}}">
                            {{time}}
                          </option>
                        </ng-container>
                      </ng-container>
                    </select>
                    <button type="button" tabindex="-1">
                      <span></span>

                      <i aria-hidden="true" class="fa fa-angle-down f23"
                        *ngIf="(productEvents[productSchedule.date] && productEvents[productSchedule.date].length > 1 && NoOfGuests > 1)">
                      </i></button>
                  </div>
                </div>
              </div>
              <!--guest-card-->
              <!--guest-card-->
              <div class="details mt-3 text-center" *ngIf="responseReceived">
                <h4><i class="fa fa-rupee"></i> {{(calculatedPrice ? calculatedPrice : product.details.sale_price) |
                  currency:'INR':'':'1.0-0'}}
                </h4>
                <ng-container *ngIf="enquiryPayLoad.number_of_guest">
                  <p>Inclusives taxes for {{enquiryPayLoad.number_of_guest}} people</p>
                </ng-container>
                <button type="submit" class="btn-yellow btn-full mt-3" (click)="addToCart()"
                  [disabled]="!availabilityPresent">
                  {{availabilityPresent ? 'Buy Now' : 'Sold Out! Select another date'}}
                </button>
                <span class="error uk-text-center"> {{checkoutError}}</span>
              </div>
              <span class="error uk-text-center" *ngIf="enquiryErrorMessage">
                {{this.enquiryErrorMessage}}
              </span>
            </form>
            <div class="key-highlight-pricing" *ngIf="1===0">
              <h4>Enquire Now</h4>
              <!-- SIGNUP -->
              <div class="border-form-input">
                <form #enquiryForm="ngForm" method="post" *ngIf="!enquirySuccessful">
                  <div class="form-group">
                    <div class="uk-inline">
                      <span class="uk-form-icon">
                        <!--<img src="assets/images/icons/people.png" alt="">-->
                        <i class="fa fa-user"></i>
                      </span>
                      <input class="uk-input" placeholder="Full Name" type="text" name="full_name" required="required"
                        minlength="4" [(ngModel)]="enquiryPayLoad.full_name" #enquiryFullName="ngModel">
                    </div>
                    <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                      <div *ngIf="enquiryFullName.errors?.required">
                        This field cannot be empty.
                      </div>
                    </span>
                  </div>
                  <div class="form-group">
                    <div class="uk-inline">
                      <span class="uk-form-icon">
                        <!--<img src="assets/images/icons/mail.png" alt="">-->
                        <i class="fa fa-envelope"></i>
                      </span>
                      <input class="uk-input" placeholder="Email Id" type="email" name="email" required="required"
                        minlength="4" [(ngModel)]="enquiryPayLoad.email" #enquiryEmail="ngModel">
                    </div>
                    <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                      <div *ngIf="enquiryEmail.errors?.required">
                        This field cannot be empty.
                      </div>
                      <div *ngIf="enquiryEmail.errors?.invalid">
                        Email is invalid.
                      </div>
                    </span>
                  </div>
                  <div class="form-group">
                    <div class="uk-inline">
                      <span class="uk-form-icon">
                        <!--<img src="assets/images/icons/call.png" alt="">-->
                        <i class="fa fa-phone"></i>
                      </span>
                      <input class="uk-input" placeholder="Enter Mobile No." type="tel" name="mobile_number"
                        required="required" minlength="10" [(ngModel)]="enquiryPayLoad.mobile_number"
                        #enquiryMobileNumber="ngModel">
                    </div>
                    <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                      <div *ngIf="enquiryMobileNumber.errors?.required">
                        This field cannot be empty.
                      </div>
                      <div *ngIf="enquiryMobileNumber.errors?.minlength">
                        Mobile number must be 10 digits.
                      </div>
                    </span>
                  </div>
                  <div class="form-group custom-radio mb-1">
                    <span>Are you planning an Occasion?</span>
                    <label><input class="uk-radio" type="radio" name="radio2" value="Yes"
                        [(ngModel)]="enquiryPayLoad.occasion"
                        checked="{{enquiryPayLoad.occasion==='Yes'?'checked':''}}"> Yes</label>
                    <label><input class="uk-radio" type="radio" name="radio2" value="No"
                        [(ngModel)]="enquiryPayLoad.occasion" checked="{{enquiryPayLoad.occasion==='No'?'checked':''}}">
                      No</label>
                  </div>
                  <div class="form-group">
                    <div class="uk-inline">
                      <span class="uk-form-icon cursor-pointer">
                        <img src="assets/images/icons/calendar.png" alt="">
                      </span>
                      <input class="uk-input" placeholder="Select your preferred dates" type="date" name="occasion_date"
                        required="required" min="{{minDate | date:'yyyy-MM-dd'}}" max="{{maxDate | date:'yyyy-MM-dd'}}"
                        [(ngModel)]="enquiryPayLoad.occasion_date" #enquiryOccasionDate="ngModel">
                    </div>


                    <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                      <div *ngIf="enquiryOccasionDate.errors?.required">
                        This field cannot be empty.
                      </div>
                    </span>
                  </div>
                  <div class="form-group mt-2">
                    <button type="submit" class="btn-yellow" (click)="submitEnquiry()">
                      <i class="fa fa-spinner fa-spin" *ngIf="enquiryResponseAwaited"></i>
                      Enquire Now
                    </button>
                    <small *ngIf="enquiryResponseReceived">{{enquiryErrorMessage}}</small>
                  </div>
                </form>
              </div>
              <!-- signup-popup -->
              <ng-container *ngIf="enquirySuccessful">
                <div class="thankyou-box">
                  <img src="assets/images/icons/right-green.png" alt="">
                  <h6>Thank you {{this.enquiryPayLoad.full_name}}</h6>
                  <p>for your response. We will reach <br> out to you shortly!</p>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!--w-30-->
      </div>
    </div>
  </section>
  <!--MORE RELATED COLLECTION-->
  <section class="more-related-collection-wrp mt-6 mb-6">
    <div class="container">
      <div class="related-collection-inner">
        <div class="heading-text text-center">
          <h4>More like this</h4>
        </div>
        <div class="related-collection-slider mt-2">
          <div uk-slider>
            <div class="uk-position-relative uk-visible-toggle uk-light mt-3" tabindex="-1">
              <app-product-card class="uk-flex uk-flex-wrap experience-wrp-inner" [data]="relatedProducts">
              </app-product-card>
            </div>
            <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin hidelg"></ul>
          </div>
        </div>
        <!--related-collection-slider-->
      </div>
    </div>
  </section>
</ng-container>
<app-standard-product [productData]="product" *ngIf="responseReceived && product.details.product_type === 'STANDARD'">
</app-standard-product>
<app-footer extraClass="footer-pb"></app-footer>